
<div class="grid">
  <div class="col-6">
    <span class="form-label">{{ 'CREATE.PASSWORD_COMPONENT.LABEL_PASSWORD' | translate }}</span>
  </div>
  <div class="col-4">
    <form>
    <input name="password" type="password" pPassword [feedback]="false" autocomplete="false"
           [(ngModel)]="password" (keyup)="notify()" [ngClass]="{'notValid': !passwordIsvalid, 'valid': passwordIsvalid}">
    </form>
  </div>
</div>
<div class="grid">
  <div class="col-6">
    <span class="form-label">{{ 'CREATE.PASSWORD_COMPONENT.LABEL_CONFIRMPASSWORD' | translate }}</span>
  </div>
  <div class="col-4">
    <form>
    <input name="verifyPassword" type="password" pPassword [feedback]="false"  autocomplete="false"
           [(ngModel)]="verifyPassword" (keyup)="notify()" [ngClass]="{'notValid': !passwordConfirmIsValid, 'valid': passwordConfirmIsValid}">
    </form>
  </div>
</div>
